import { DatagramBuf } from "~/classes/generated/datagram"
import { GuestLogoutLocalDatagramBuf, LocalDatagramBuf } from "~/classes/generated/local"
import { createAnonIdBuf } from "~/utils/flatbuffers/anonymous"
import { DatagramBufferBuilder } from "~/utils/flatbuffers/builder"

const _console = useLogger("local/guest-logout")

export function sendLocalGuestLogoutRequest(anonId: string) {
  const { sendWorkerDatagramBuf } = useCache()

  const fbb = new DatagramBufferBuilder(64)
  const anonIdBuf = createAnonIdBuf(fbb, anonId)
  GuestLogoutLocalDatagramBuf.startGuestLogoutLocalDatagramBuf(fbb)
  GuestLogoutLocalDatagramBuf.addAnonId(fbb, anonIdBuf)
  const guestLogout = GuestLogoutLocalDatagramBuf.endGuestLogoutLocalDatagramBuf(fbb)

  LocalDatagramBuf.startLocalDatagramBuf(fbb)
  LocalDatagramBuf.addGuestLogout(fbb, guestLogout)
  const local = DatagramBuf.createLocalVector(fbb, [LocalDatagramBuf.endLocalDatagramBuf(fbb)])

  DatagramBuf.startDatagramBuf(fbb)
  DatagramBuf.addLocal(fbb, local)
  fbb.finish(DatagramBuf.endDatagramBuf(fbb))
  sendWorkerDatagramBuf(fbb.asUint8Array())
}
